import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { ChecklistsDashboardQueryKeys } from "modules/ChecklistsDashboard/queryKeys";
import { removeLocationChecklist } from "modules/ChecklistsDashboard/util";
import { ApiInstance } from "utils/Api";

import type { ChecklistID, DealerLocationID } from "models";

type DetachChecklistFromLocationPayload = {
  checklist_id: ChecklistID;
  dealer_location_id: DealerLocationID;
};

export const useDetachChecklistFromLocationMutation = () =>
  useTypedMutation<DetachChecklistFromLocationPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/checklists/location/detach", payload, ENV.dealerBaseURL);
    },
    onSuccess: ({ checklist_id, dealer_location_id }) => {
      const locationChecklists = typedQueryClient.getQueryData(ChecklistsDashboardQueryKeys.locationChecklists(dealer_location_id));
      if (!locationChecklists?.length) return;

      const checklistIdx = locationChecklists.findIndex(lc => lc.id === checklist_id);
      if (checklistIdx === -1) return;

      typedQueryClient.setQueryData(ChecklistsDashboardQueryKeys.locationChecklists(dealer_location_id), removeLocationChecklist(locationChecklists, checklistIdx));
    }
  });
